export default function Link(theme: any) {
    return {
        styleOverrides: {
            root: {
               textDecoration:"none"
              }
        }
    }
}